export default "/_next/static/media/enjoei-collectionwidget4-1024x413.32f4958cc934fa894c29b6a9dc771f0c.png";